import { ItemFilter } from '../../graphql/graphql';
import { BreadcrumbI } from '../Breadcrumbs';
import { ItemConnectionSort } from '../../graphql/types';

export interface TransformedObj {
  filter: ItemFilter;
  sorting: ItemConnectionSort;
}

export interface GeneralAdsPageProps {
  transformedObj: TransformedObj;
  setErrorUI: (value: boolean) => void;
  h1?: string;
  breadcrumbs?: BreadcrumbI[];
  isSearchPage?: boolean;
  isItemsAllPage?: boolean;
}

export enum PriceViewMode {
  PerArea = 'perArea',
  PerAcre = 'perAcre'
}

export interface ToggleOption {
  id: PriceViewMode;
  name: string;
}
